import { AbstractControl } from '@angular/forms';
import { of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EmailValidationError } from 'src/app/errors/user-errors/user.errors';
import { logErrorMessage } from 'src/app/helpers/retry.operators';
import { EmailUniqueCheckService } from 'src/app/services/sign-up/email-unique-check.service';

// Wait for typing to settle before hitting the API. Angular tears down the
// previous async validation subscription on every value change, so a pending
// timer is cancelled by the next keystroke and only the last one gets through.
const DEBOUNCE_MS = 600

// Compare and send the same normalized form the registration payload submits,
// otherwise a capitalized address is checked but a lowercased one is stored.
function normalize(email: any): string {
  return (email || '').toString().trim().toLowerCase()
}

export class ValidateUniqueEmail {

    static valid(checkEmailUniqueService: EmailUniqueCheckService, system: string, userEmail: string) {
        return (control: AbstractControl) => {

          const email = normalize(control.value)

          return timer(DEBOUNCE_MS).pipe(
          switchMap(() => checkEmailUniqueService.checkIfEmailUnique(email, system)),
          map(res => {

            // No usable answer is not the same as "this e-mail is free" —
            // fail closed so the control resolves to INVALID instead of
            // sitting at PENDING, which the sign-up card treats as passable.
            if(res === undefined || res === null) return { emailCheckFailed: true }

            if(normalize(userEmail) === email || res.is_valid)
              return null
            else
              return { emailTaken: true }

          }),
          catchError(error => {

            let sentryContext: any = {
              errorName: 'Error Validating E-mail.',
              userEmail,
              errorMessage: "There was an error validating this e-mail.",
              error: null
            }

            sentryContext.error = new EmailValidationError(sentryContext.errorName)

            logErrorMessage(3, error, sentryContext, null)

            return of({ emailCheckFailed: true })

          }))

        }
    }

}
